import React, { useState, useRef, useEffect } from "react";

const QuantityInput = ({ initialQty = 1, onChange }) => {
  const [displayQty, setDisplayQty] = useState(String(initialQty));
  const lastValidQty = useRef(initialQty);
  const inputRef = useRef(null);
  const isFocused = useRef(false);

 
  useEffect(() => {
    lastValidQty.current = Number(initialQty);
    setDisplayQty(String(initialQty)); 
  }, [initialQty]);

  const processQuantity = () => {
    const value = displayQty.trim();

    if (value === "" || value === "0") {
      // Restore PREVIOUS correct quantity
      const restored = String(lastValidQty.current);
      setDisplayQty(restored);
      onChange?.(lastValidQty.current);
    } else {
      const newQty = parseInt(value, 10);
      lastValidQty.current = newQty;
      setDisplayQty(String(newQty));
      onChange?.(newQty);
    }
  };

  const handleChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    setDisplayQty(value);

    // Keep cursor on right always
    requestAnimationFrame(() => {
      const input = inputRef.current;
      if (input) {
        const len = input.value.length;
        input.setSelectionRange(len, len);
      }
    });
  };

  const handleBlur = () => {
    isFocused.current = false;
    processQuantity();
  };

  const handleFocus = () => {
    isFocused.current = true;

    // Move cursor to right
    requestAnimationFrame(() => {
      const input = inputRef.current;
      if (input) {
        const len = input.value.length;
        input.setSelectionRange(len, len);
      }
    });
  };

  // Detect mobile keyboard close
  useEffect(() => {
    if (!window.visualViewport) return;

    let lastHeight = window.visualViewport.height;

    const handleResize = () => {
      const newHeight = window.visualViewport.height;

      // Keyboard closed (viewport height increases)
      if (newHeight > lastHeight + 50 && isFocused.current) {
        processQuantity();
        inputRef.current?.blur();
      }

      lastHeight = newHeight;
    };

    window.visualViewport.addEventListener("resize", handleResize);

    return () =>
      window.visualViewport.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="min-w-[20px] cursor-pointer"
      onClick={() => inputRef.current?.focus()}
    >
      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={displayQty}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        className="w-[20px] text-center border-none bg-transparent outline-none text-sm font-semibold"
      />
    </div>
  );
};

export default QuantityInput;
